import { exportTranslateStaticLoader } from './common-theme/i18n/translate-browser-loader.service';
var ɵ0 = exportTranslateStaticLoader;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };



// WEBPACK FOOTER //
// ./src/app/app.module.ts.pre-build-optimizer.js